/* Favoris et « Récemment consultés » : enregistrés dans le navigateur (localStorage), sans compte. */
(() => {
  if (window.DbStore) return;

  const read = (key) => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  };
  const write = (key, list) => {
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
      /* stockage indisponible (navigation privée) : on ignore */
    }
  };

  const cardCache = new Map();
  const DbStore = {
    FAV: 'db:favoris',
    RECENT: 'db:recent',
    get: read,
    has(key, handle) {
      return read(key).includes(handle);
    },
    toggleFavorite(handle) {
      const list = read(this.FAV);
      const index = list.indexOf(handle);
      if (index === -1) list.unshift(handle);
      else list.splice(index, 1);
      write(this.FAV, list.slice(0, 60));
      document.dispatchEvent(new CustomEvent('db:favorites-changed'));
      return index === -1;
    },
    removeFavorite(handle) {
      write(this.FAV, read(this.FAV).filter((h) => h !== handle));
      document.dispatchEvent(new CustomEvent('db:favorites-changed'));
    },
    addRecent(handle) {
      const list = read(this.RECENT).filter((h) => h !== handle);
      list.unshift(handle);
      write(this.RECENT, list.slice(0, 12));
    },
    clearRecent() {
      write(this.RECENT, []);
    },
    // Récupère le HTML d'une carte produit via la section db-product-card
    fetchCard(handle) {
      if (!cardCache.has(handle)) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        cardCache.set(
          handle,
          fetch(`${root}products/${encodeURIComponent(handle)}?section_id=db-product-card`)
            .then((response) => (response.ok ? response.text() : ''))
            .then((html) => {
              const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-db-card-for]');
              return node ? node.innerHTML : '';
            })
            .catch(() => '')
        );
      }
      return cardCache.get(handle);
    },
  };
  window.DbStore = DbStore;

  /* --- Cœurs sur les cartes ------------------------------------------------ */
  const syncHearts = () => {
    const favorites = read(DbStore.FAV);
    document.querySelectorAll('[data-db-fav]').forEach((button) => {
      const active = favorites.includes(button.dataset.dbFav);
      if (button.getAttribute('aria-pressed') === String(active)) return;
      button.setAttribute('aria-pressed', active);
      button.setAttribute('aria-label', active ? button.dataset.labelRemove : button.dataset.labelAdd);
      const icon = button.querySelector('.db-fav__icon');
      const text = button.querySelector('.db-fav__text');
      if (icon) icon.textContent = active ? '❤️' : '🤍';
      if (text) text.textContent = active ? button.dataset.textRemove : button.dataset.textAdd;
    });
    document.querySelectorAll('[data-db-fav-count]').forEach((badge) => {
      // n'écrire que si nécessaire : une écriture déclencherait le MutationObserver ci-dessous
      if (badge.textContent !== String(favorites.length)) badge.textContent = favorites.length;
      if (badge.hidden !== (favorites.length === 0)) badge.hidden = favorites.length === 0;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-db-fav]');
    if (!button) return;
    event.preventDefault();
    const added = DbStore.toggleFavorite(button.dataset.dbFav);
    button.classList.remove('is-pop');
    void button.offsetWidth;
    if (added) button.classList.add('is-pop');
  });
  document.addEventListener('db:favorites-changed', syncHearts);
  window.addEventListener('storage', (event) => {
    if (event.key === DbStore.FAV) syncHearts();
  });
  // Cartes ajoutées dynamiquement (filtres, séries, récents…)
  new MutationObserver(() => {
    clearTimeout(DbStore.syncTimer);
    DbStore.syncTimer = setTimeout(syncHearts, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  syncHearts();

  /* --- Tiroir des favoris ---------------------------------------------------- */
  if (!customElements.get('db-wishlist-drawer')) {
    customElements.define(
      'db-wishlist-drawer',
      class DbWishlistDrawer extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-db-wishlist-list]');
          this.empty = this.querySelector('[data-db-wishlist-empty]');
          this.querySelectorAll('[data-db-wishlist-close]').forEach((el) => el.addEventListener('click', () => this.close()));
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
          });
          document.addEventListener('click', (event) => {
            const opener = event.target.closest('[data-db-wishlist-open]');
            if (!opener) return;
            event.preventDefault();
            this.opener = opener;
            this.open();
          });
          document.addEventListener('db:favorites-changed', () => {
            if (this.classList.contains('is-open')) this.render();
          });
        }

        open() {
          this.hidden = false;
          requestAnimationFrame(() => this.classList.add('is-open'));
          document.body.classList.add('overflow-hidden');
          this.render();
          const close = this.querySelector('.db-wishlist__close');
          if (close) close.focus();
        }

        close() {
          this.classList.remove('is-open');
          document.body.classList.remove('overflow-hidden');
          setTimeout(() => (this.hidden = true), 350);
          if (this.opener) this.opener.focus();
        }

        async render() {
          const handles = DbStore.get(DbStore.FAV);
          this.empty.hidden = handles.length > 0;
          const cards = await Promise.all(handles.map((h) => DbStore.fetchCard(h)));
          this.list.innerHTML = '';
          cards.forEach((html, i) => {
            if (!html) {
              // produit supprimé ou dépublié
              DbStore.removeFavorite(handles[i]);
              return;
            }
            const li = document.createElement('li');
            li.className = 'db-grid__item';
            li.innerHTML = html;
            this.list.appendChild(li);
          });
          syncHearts();
        }
      }
    );
  }

  /* --- Récemment consultés --------------------------------------------------- */
  if (!customElements.get('db-recent')) {
    customElements.define(
      'db-recent',
      class DbRecent extends HTMLElement {
        async connectedCallback() {
          const current = this.dataset.current;
          const handles = DbStore.get(DbStore.RECENT).filter((h) => h !== current);
          if (current) DbStore.addRecent(current);
          const limit = parseInt(this.dataset.limit, 10) || 4;
          if (handles.length === 0) return;

          const list = this.querySelector('[data-db-recent-list]');
          const cards = await Promise.all(handles.slice(0, limit).map((h) => DbStore.fetchCard(h)));
          cards.filter(Boolean).forEach((html) => {
            const li = document.createElement('li');
            li.className = 'db-grid__item';
            li.innerHTML = html;
            list.appendChild(li);
          });
          if (!list.children.length) return;
          this.hidden = false;
          syncHearts();

          const clear = this.querySelector('[data-db-recent-clear]');
          if (clear) {
            clear.addEventListener('click', () => {
              DbStore.clearRecent();
              if (current) DbStore.addRecent(current);
              this.hidden = true;
            });
          }
        }
      }
    );
  }
})();
